// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__Vye0s","gfeWrapper":"CalendarEvent_gfeWrapper__2FKhy"};